import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/error-tracker.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"app/layout.js\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../public/fonts/Poppins-Bold.ttf\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"../public/fonts/Poppins-Regular.ttf\",\"weight\":\"400\",\"style\":\"normal\"}],\"variable\":\"--font-poppins\",\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
